import { SectionLabel } from '../ui/SectionLabel'

const PAINS = [
  'Tardas horas en estructurar un guion que termina sonando artificial',
  'Sin consistencia entre vídeos — cada uno suena a alguien diferente',
  'Tus mejores ideas se pierden en notas dispersas que nunca revisas',
  'No sabes qué funciona hasta que publicas y ya es demasiado tarde',
]

const cx = 'max-w-[1100px] mx-auto px-5 sm:px-8'

export function PainPoints() {
  return (
    <section className="py-24 border-b border-ds-border bg-ds-surface">
      <div className={cx}>
        <SectionLabel className="mb-5">¿Te suena esto?</SectionLabel>
        <h2 className="font-display font-black text-[clamp(48px,5vw,80px)] leading-headline tracking-tight2 uppercase text-ds-text max-w-[700px] mb-14">
          El problema no
          <br />
          es la <span className="italic text-ds-red">falta de ideas.</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[1px] bg-ds-border-mid border border-ds-border-mid">
          {PAINS.map((pain, i) => (
            <div key={i} className="bg-ds-surface p-7 py-8">
              <div className="font-display font-black text-[24px] text-ds-red opacity-50 mb-3">
                ✕
              </div>
              <p className="font-sans text-[13px] text-ds-muted leading-[1.65]">{pain}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-12 border-t border-ds-border">
          <p className="font-display font-black text-[clamp(28px,3vw,40px)] tracking-tight1 uppercase text-ds-text max-w-[720px]">
            Es el tiempo entre la idea
            <br />
            <span className="text-ds-muted">y el vídeo publicado.</span>
          </p>
        </div>
      </div>
    </section>
  )
}
